import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Nav = styled.nav`
  display: flex;
  padding: 0 2rem;

  align-items: center;
  border-bottom: 1px solid #adb5bd;
`;

const Title = styled.h1`
  margin-right: 2rem;
`;

const HyperLink = styled(Link)`
  color: #343a40;
  margin-right: 1rem;
`;

const NavBar = () => (
  <Nav>
    <Title>neuro-ts 🧬</Title>
    <HyperLink to="/asteroid">Catch the Asteroid</HyperLink>
  </Nav>
);

export default NavBar;
